/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preset_Name_LabelInputs */

const en_video_export_preset_name_label = /** @type {(inputs: Video_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset Name`)
};

const fr_video_export_preset_name_label = /** @type {(inputs: Video_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du prereglage`)
};

const de_video_export_preset_name_label = /** @type {(inputs: Video_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreingestellter Name`)
};

const it_video_export_preset_name_label = /** @type {(inputs: Video_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome predefinito`)
};

const ru_video_export_preset_name_label = /** @type {(inputs: Video_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название предустановки`)
};

const es_video_export_preset_name_label = /** @type {(inputs: Video_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del preajuste`)
};

const zh_cn2_video_export_preset_name_label = /** @type {(inputs: Video_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设名称`)
};

const ja_video_export_preset_name_label = /** @type {(inputs: Video_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセット名`)
};

const hi_video_export_preset_name_label = /** @type {(inputs: Video_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट नाम`)
};

const pt_pt2_video_export_preset_name_label = /** @type {(inputs: Video_Export_Preset_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome predefinido`)
};

/**
* | output |
* | --- |
* | "Preset Name" |
*
* @param {Video_Export_Preset_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_name_label = /** @type {((inputs?: Video_Export_Preset_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preset_name_label(inputs)
	if (locale === "de") return de_video_export_preset_name_label(inputs)
	if (locale === "it") return it_video_export_preset_name_label(inputs)
	if (locale === "ru") return ru_video_export_preset_name_label(inputs)
	if (locale === "es") return es_video_export_preset_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preset_name_label(inputs)
	if (locale === "ja") return ja_video_export_preset_name_label(inputs)
	if (locale === "hi") return hi_video_export_preset_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preset_name_label(inputs)
	return en_video_export_preset_name_label(inputs)
});